module.exports = __webpack_public_path__ + "static/media/openbrix@2x.30586bf4.png";